const config = {
  all: {
    env: process.env.NODE_ENV || 'development',
    isDev: process.env.NODE_ENV !== 'production',
    basename: process.env.PUBLIC_PATH || '/',
    baseApi: process.env.REACT_APP_BASE_API || '',
    isBrowser: typeof window !== 'undefined',
    drawerWidth: 292,
    drawerOpen: true,
    cardHeight: 233,
    rowsPerPage: 10,
    googleReCaptchaKey: '6LfGuTAaAAAAAJVrGYMN5BWk8GxrNQgiCXx6q1Gn',
    currencyDecimalScale: 2,
    freshChat: {
      token: '440c81c0-c552-4350-b4ac-8350aa97d507',
      host: 'https://wchat.freshchat.com'
    },
    loginEcpf: {
      id: '11807',
      name: 'consignet-v3',
      formAction: 'https://autenticador.certisign.com.br/CertisignLogin/certificado/login',
      urlRetorno: `${process.env.REACT_APP_BASE_API}/api/authentication/e-cpf/certisign`
    },
    validateCaptcha: process.env.REACT_APP_VALIDATE_CAPTCHA || true,
    system: {
      name: process.env.REACT_APP_SYSTEM,
      brand: process.env.REACT_APP_BRAND,
      favicon: process.env.REACT_APP_FAVICON,
      logo: process.env.REACT_APP_LOGO,
      logoHeader: process.env.REACT_APP_LOGO_HEADER,
      title: process.env.REACT_APP_TITLE,
      url: process.env.REACT_APP_URL,
      holding: process.env.REACT_APP_HOLDING,
      isVan: process.env.REACT_APP_IS_VAN === 'true',
      linkWhatsApp: process.env.REACT_APP_LINK_WHATSAPP,
      linkFreshDesk: process.env.REACT_APP_LINK_FRESHDESK
    }
  },
  test: {
    isDev: false
  },
  development: {},
  production: {}
}

export default {
  ...config.all,
  ...config[config.all.env]
}
